// extracted by mini-css-extract-plugin
export default {"flash":"flash__3LqSn"};